export const TICKET_TYPES = {
  MEMBERSHIP: 'membership',
  TEAM: 'team',
  REGULAR: 'regular',
};

/**
 * Derives the ticket type string from a backend ticket model's
 * membershipTicket / teamTicket flags.
 */
export const getTicketType = (ticket) => {
  if (ticket.membershipTicket) return TICKET_TYPES.MEMBERSHIP;
  if (ticket.teamTicket) return TICKET_TYPES.TEAM;
  return TICKET_TYPES.REGULAR;
};
